import { render, staticRenderFns } from "./_studentId.vue?vue&type=template&id=cdc62478&"
import script from "./_studentId.vue?vue&type=script&lang=js&"
export * from "./_studentId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports